import React, { useEffect } from "react";
import Buttons from "components/UI/Button/Buttons";
import "./HomePage.scss";
import display from "images/display.png";
import flex from "images/flex.png";
import battery from "images/battery.png";
import logo from "images/logocelularfire.png";
import { useHistory } from "react-router-dom";

const HomePage = () => {
    const history = useHistory();
    useEffect(() => window.scrollTo(0, 0), []);
    if (window.localStorage.getItem("account") === "true") {
        history.push("/panel-control");
    }
    const handelPriceList = () => history.push("lista-precios");

    return (
        <section className="homePage">
            <div className="homePage__info">
                <img src={logo} alt="" />
                <h2>Refacciones para dispositivos móviles</h2>
                <p>
                    Somos líderes en mayoreo y menudeo con la mejor calidad,
                    precio y servicio, contando con más de 10 sucursales en
                    México y 10 años de experiencia.
                </p>
                <p>
                    Conoce nuestra <span onClick={handelPriceList}>
                        lista de precios haciendo click aquí
                    </span> y contáctate con una de nuestras sucursales para solicitar
                    la refacción que necesitas.
                </p>
                <Buttons
                    redirectTo="/sucursales"
                    className="info__btn--branchOffices btnPrimary"
                >
                    Sucursales
                </Buttons>
                <Buttons
                    redirectTo="/sobre-nosotros"
                    className="info__btn--about btnSecondary"
                >
                    Sobre Nosotros
                </Buttons>
            </div>
            <div className="homePage__imagesDesktop">
                <img
                    className="imagesDesktop__displayImage"
                    src={display}
                    alt=""
                />
                <img className="imagesDesktop__flexImage" src={flex} alt="" />
                <img
                    className="imagesDesktop__batteryImage"
                    src={battery}
                    alt=""
                />
                <div className="imagesDesktop__shadowImage"></div>
            </div>
        </section>
    );
};

export default HomePage;
